import React, {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import useCustomPreferencesListQuery from '../custom-hooks/use-custom-preferences-list'

export const CustomPreferencesContext = createContext()

export const CustomPreferencesProvider = ({children}) => {
    const {data} = useCustomPreferencesListQuery()

    return (
        <CustomPreferencesContext.Provider value={data?.data || []}>
            {children}
        </CustomPreferencesContext.Provider>
    )
}

CustomPreferencesProvider.propTypes = {
    children: PropTypes.node.isRequired,
}

export const useCustomPreferences = () => {
    const context = useContext(CustomPreferencesContext)
    if (!context) {
        throw new Error('useCustomPreferences must be used within a CustomPreferencesProvider')
    }
    return context
}
